import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    ClientName: {
      validations: []
    },
    Email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: []
    },
    Theme: {
      validations: []
    },
    PlannedGuestCount: {
      validations: []
    },
    SiteName: {
      validations: []
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName',
            customClasses:['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company',
            mapping: 'ClientName',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email',
            customClasses:['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'TelNumber',
            customClasses:['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'AddressLine1',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City',
            mapping: 'City',
            customClasses:['no-label']
          },
          {
            type: 'text',
            size: 'XSmall',
            label: 'State',
            mapping: 'State',
            customClasses:['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postal',
            mapping: 'Postal',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Nature of event',
            mapping: 'Theme',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of guests',
            mapping: 'PlannedGuestCount',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice-nolabel',
            size: 'Medium',
            label: 'Choose Location',
            mapping: 'SiteName',
            options: [
              { label: 'City Roots' , value: 'City Roots'},
              { label: 'Loft 201', value: 'Loft 201'},
              { label: '701 Whaley', value: '701 Whaley'},
              { label: 'Hunter Gather', value: 'Hunter Gather' },
              { label: 'Hampton Preston Mansion', value: 'Hampton Preston Mansion' },
              { label: 'Robert Mills House', value: 'Robert Mills House' },
              { label: 'Siebels House', value: 'Siebels House' },
              { label: 'Columbia Museum of Art', value: 'Columbia Museum of Art' },
              { label: 'Woodrow Wilson Family Home', value: 'Woodrow Wilson Family Home' },
              { label: 'River Center at Saluda Shoals', value: 'River Center at Saluda Shoals' },
              { label: 'Stone River', value: 'Stone River' },
              { label: 'Pastors Study at LuLa Drake', value: 'Pastors Study at LuLa Drake' },
              { label: 'Tin Roof Farms', value: 'Tin Roof Farms' },
              { label: '12 Oak Estate', value: '12 Oak Estate' },
              { label: 'White Mule', value: 'White Mule' },
              { label: 'Other', value: 'Other' }
            ],
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Description of event',
            mapping: 'Notes',
            customClasses:['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'F2T Productions Catering Contact Form',
    formId: '485',
    clientKey: 'F0F2F92D-C3D5-480D-81F2-CA4279CA817C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/f2tproductions/form_structure.js